import { Accordion } from "@mantine/core";

export const BaseAccordion = Accordion